import * as d3 from "d3";
import { calcBoundedLimit } from "./utils";

/**
 * @this {import('alpinejs').AlpineComponent}
 */
export default function simpleDonutChart(options) {
  let boundedHeight;
  let boundedWidth;
  let x;
  let placementTraits;
  let placementTexte;
  let textAnchorText;
  let arc;
  let data;
  let arcLibelle;
  let pie;
  let data_ready;
  let radiusInterne;
  let radiusExterne;
  let radius;
  let show = false;
  let animate = false;

  const scales = (colorRange) => {
    radius = window.innerWidth > 1024 ? 250 : 90;
    radiusInterne = radius * 0.275;
    radiusExterne = radius * 0.5;

    arc = d3.arc().innerRadius(radiusInterne).outerRadius(radiusExterne);

    //cercle invisible pour le placement des libellés
    arcLibelle = d3
      .arc()
      .innerRadius((radiusExterne = radius * 0.55))
      .outerRadius((radiusExterne = radius * 0.55));

    x = d3.scaleOrdinal().domain(data).range(colorRange.slice(0, data.length));
  };

  const initializeSvg = (width, height, margin) => {
    const { boundedHeight: bh, boundedWidth: bw } = calcBoundedLimit(
      width,
      height,
      margin
    );
    boundedHeight = bh;
    boundedWidth = bw;
  };

  return {
    ...options,
    async init() {
      data = await d3.csv(options.url);
      pie = d3
        .pie()
        .value(function (d) {
          return +d?.[options.xIndex];
        })
        .sort(function (a, b) {
          return a?.[options.xIndex] < b?.[options.xIndex];
        });
      data_ready = pie(data);

      this.$watch("width", () => {
        this.show = false;
        // on re-calcule tout
        initializeSvg(this.width, this.height, this.margin);
        scales(this.colorRange, boundedHeight);
        this.$nextTick(() => (this.show = true));
      });
    },
    translateChart() {
      return `translate(${
        window.innerWidth > 800 ? boundedWidth / 1.8 : boundedWidth / 2.4
      },${boundedHeight / 2})`;
    },
    functionPoints(d) {
      var posA = arc.centroid(d);
      var posB = arcLibelle.centroid(d);
      var posC = arcLibelle.centroid(d);
      posC[0] =
        radius *
        0.55 *
        0.95 *
        (d.startAngle + (d.endAngle - d.startAngle) / 2 < Math.PI ? 1 : -1);
      return [posA, posB, posC];
    },
    functionTransform(d) {
      var pos = arcLibelle.centroid(d);
      pos[0] =
        radius *
        0.55 *
        0.99 *
        (d.startAngle + (d.endAngle - d.startAngle) / 2 < Math.PI ? 1 : -1);
      return `translate(` + pos + `)`;
    },
    functionTextAnchor(d) {
      return d.startAngle + (d.endAngle - d.startAngle) / 2 < Math.PI
        ? `start`
        : `end`;
    },
    splitAt(s, at) {
      return [
        s.split(" ").slice(0, at).join(" "),
        s.split(" ").slice(at).join(" "),
      ].filter(Boolean);
    },
    get data() {
      return data;
    },
    get data_ready() {
      return data_ready;
    },
    get x() {
      return x;
    },
    set x(a) {
      x = a;
    },
    get arc() {
      return arc;
    },
    set arc(a) {
      arc = a;
    },
    get arcLibelle() {
      return arcLibelle;
    },
    set arcLibelle(a) {
      arcLibelle = a;
    },
    get placementTexte() {
      return placementTexte;
    },
    set placementTexte(s) {
      placementTexte = s;
    },
    get placementTraits() {
      return placementTraits;
    },
    set placementTraits(s) {
      placementTraits = s;
    },
    get textAnchorText() {
      return textAnchorText;
    },
    set textAnchorText(s) {
      textAnchorText = s;
    },
    get show() {
      return show;
    },
    set show(s) {
      show = s;
    },
    get animate() {
      return animate;
    },
    set animate(a) {
      animate = a;
    },
  };
}
